export default {
  name: 'InfoBox',
  props: {
    classes: {
      default: '',
      type: String
    },
    title: {
      default: '',
      type: String
    },
    total: {
      required: true,
      type: [ Number, String ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/InfoBox/InfoBox.js